import { IMeta } from "react-dropzone-uploader";
import { atom, selector, selectorFamily } from "recoil";

import graphQLClient from "graphql/react-query";
import { CURRENT_COUNTRY } from "src/constants/Countries";

import {
  GetOrderByIdDocument,
  GetProductByFilterDocument,
  OrderModel,
  RegionType
} from "../../graphql/generated";
import keys from "./constants";
import { routerChangeState } from "./generalState";

export const orderIdState = atom<string>({
  key: keys.BOOKING_ORDERID_STATE,
  default: undefined
});
export const orderByIdState = selectorFamily({
  key: keys.BOOKING_ORDER_BY_ID_STATE,
  get:
    (sysId: string) =>
    // eslint-disable-next-line consistent-return
    async ({ get }) => {
      get(routerChangeState);

      const orderByIdData = await graphQLClient.request(GetOrderByIdDocument, {
        id: sysId
      });

      if (!orderByIdData?.getOrderById) return null;

      let orderData = orderByIdData.getOrderById;

      if (orderData.evaluationId) {
        const productData = await graphQLClient.request(GetProductByFilterDocument, {
          input: {
            id: orderData.evaluationId,
            country: CURRENT_COUNTRY as RegionType
          }
        });
        const productGroup = productData?.getProductByFilter[0];

        if (productGroup) {
          const productGroupData = productGroup;
          orderData = { ...orderData, productGroupData };
        }
      }

      return orderData;
    }
});

export const orderState = selector<OrderModel>({
  key: keys.BOOKING_ORDER_STATE,
  get: async ({ get }) => {
    get(routerChangeState);

    const orderId = get(orderIdState);
    if (!orderId) return null;

    const order = get(orderByIdState(orderId));

    if (!order || (order.acuityAppointmentSnapshot && order.delivery)) return null;

    return order;
  }
});

export const editDeliveryOrderId = atom<string>({
  key: keys.EDIT_DELIVERY_ORDER_ID,
  default: undefined
});

export const editDeliveryConsultDate = atom<string>({
  key: keys.EDIT_DELIVERY_CONSULT_DATE,
  default: undefined
});

export const uploadedDocumentState = atom<{ meta: IMeta }[]>({
  key: keys.UPLOADED_DOCUMENT_STATE,
  default: null
});

export const showNormalThankYouHeaderState = atom<boolean>({
  key: keys.SHOW_NORMAL_THANK_YOU_HEADER,
  default: true
});
